(function () {
  var STORAGE_KEY = 'bf_wishlist';

  function readWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (error) {
      /* localStorage unavailable (private mode, quota, etc.) */
    }
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { items: items } }));
  }

  function isSaved(handle) {
    return readWishlist().some(function (item) {
      return item.handle === handle;
    });
  }

  function toggleItem(data) {
    var items = readWishlist();
    var index = items.findIndex(function (item) {
      return item.handle === data.handle;
    });
    var added;
    if (index > -1) {
      items.splice(index, 1);
      added = false;
    } else {
      items.push(data);
      added = true;
    }
    writeWishlist(items);
    return added;
  }

  function removeItem(handle) {
    var items = readWishlist().filter(function (item) {
      return item.handle !== handle;
    });
    writeWishlist(items);
  }

  function updateBadges() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  function syncButtons() {
    var handles = readWishlist().map(function (item) {
      return item.handle;
    });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var active = handles.indexOf(handle) > -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function refresh() {
    updateBadges();
    syncButtons();
  }

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-wishlist-toggle]');
      if (!this.button) return;
      this.onClick = this.onClick.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
    }

    onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      var data = {
        handle: this.button.getAttribute('data-product-handle'),
        id: this.button.getAttribute('data-product-id'),
        title: this.button.getAttribute('data-product-title'),
        image: this.button.getAttribute('data-product-image'),
        url: this.button.getAttribute('data-product-url'),
        price: this.button.getAttribute('data-product-price'),
      };
      if (!data.handle) return;
      toggleItem(data);
    }
  }

  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', WishlistButton);
  }

  document.addEventListener('wishlist:change', refresh);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }

  window.BFWishlist = {
    read: readWishlist,
    toggle: toggleItem,
    remove: removeItem,
    isSaved: isSaved,
    refresh: refresh,
  };
})();
